export const ARTICLE_RELATED_ITEMS_LIMIT = 12;

export type ArticleRelatedItemsSlice = {
    itemIds: number[];
};

export type FetchArticleRelatedItemsParams = {
    keyword: string;
};

export const defaultArticleRelatedItemsSlice: ArticleRelatedItemsSlice = {
    itemIds: [],
};
